import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetPublishedConnectionTableNameParams {
  readonly id: string;
  readonly name: string;
}

export interface SetPublishedConnectionTableNameResult extends IResult {
}

export class SetPublishedConnectionTableNameRequest extends Request<SetPublishedConnectionTableNameParams, SetPublishedConnectionTableNameResult> {
  constructor(params: SetPublishedConnectionTableNameParams) {
    super('setPublishedConnectionTableName', params);
  }
}
